import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { SVG_COMPONENTS } from '@/assets/admin';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';

const CloseIcon = SVG_COMPONENTS.CANCEL_X;

interface CloseButtonProps {
  onPress: () => void;
  color?: string;
  size?: number;
  hitSlop?: { top: number; bottom: number; left: number; right: number };
}

/**
 * Reusable close button with X icon
 */
export const CloseButton: React.FC<CloseButtonProps> = ({
  onPress,
  color = MARKETPLACE_COLORS.textMuted,
  size = 16,
  hitSlop = { top: 10, bottom: 10, left: 10, right: 10 },
}) => (
  <TouchableOpacity
    style={styles.button}
    onPress={onPress}
    activeOpacity={0.8}
    hitSlop={hitSlop}
  >
    <CloseIcon width={size} height={size} color={color} />
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  button: {
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

